import request from '@/utils/request'
const baseUrl = '/personal'

/**
 * 个人中心页 数据
 */
export function getPersonal(userId) {
  return request({
    url: `${baseUrl}/private/rest/index/${userId}`,
    method: 'GET'
  })
}

/**
 * 查看是否关注此用户
 */
export function isFollow(userId) {
  return request({
    url: `${baseUrl}/private/rest/isFollow/${userId}`,
    method: 'GET'
  })
}

/**
 * 关注/取消关注用户
 */
export function follow(userId) {
  return request({
    url: `${baseUrl}/private/rest/follow/${userId}`,
    method: 'GET'
  })
}

/**
 * 个人中心页 作品列表
 */
export function getWorksList(data) {
  let url = `/works/private/rest/list`
  if (data.userId) {
    url = `/works/rest/list/${data.userId}`
  }
  return request({
    url: url,
    method: 'POST',
    data
  })
}

/**
 * 个人中心页 用户hdr作品
 */
export function getHdrList(data) {
  let url = `/works/private/rest/hdrList`
  if (data.userId) {
    url = `/works/rest/hdrList/${data.userId}`
  }
  return request({
    url: url,
    method: 'POST',
    data
  })
}

/**
 * 个人中心页 用户展映作品
 */
export function getShowList(data) {
  let url = `/works/private/rest/showList`
  if (data.userId) {
    url = `/works/rest/showList/${data.userId}`
  }
  return request({
    url: url,
    method: 'POST',
    data
  })
}

/**
 * 个人中心页 素材
 */
export function getPersonalMaterial(data) {
  return request({
    url: `/material/private/rest/getPersonalMaterial`,
    method: 'POST',
    data
  })
}

/**
 * 个人中心 素材 管理
 */
export function getManagePersonalMaterial(data) {
  return request({
    url: `/material/private/rest/getManagePersonalMaterial`,
    method: 'POST',
    data
  })
}

/**
 * 个人中心页 学院
 */
export function getPersonalCourse(data) {
  return request({
    url: `/college/private/rest/getPersonalCourse`,
    method: 'POST',
    data
  })
}

/**
 * 个人中心页 学院管理
 */
export function getSetPersonalCourse(data) {
  return request({
    url: `/college/private/rest/getSetPersonalCourse`,
    method: 'POST',
    data
  })
}
/**
 * 个人中心页 我的学院作品池
 */
export function personalCworksList(data) {
  return request({
    url: `/college/private/rest/personalCworksList`,
    method: 'POST',
    data
  })
}

/**
 * 获取个人中心48作品,默认分站赛id请传值0
 */
export function getPersonal48Works(data) {
  let url = `/newgaia48/private/rest/getPersonal48Works`
  if (!data.isSelf) {
    url = `/newgaia48/rest/getPersonal48Works/${data.userId}`
  }
  return request({
    url: url,
    method: 'POST',
    data
  })
}

/**
 * 删除个人中心作品
 * @param {*} id 作品id
 */
export function delWorks(id) {
  return request({
    url: `/works/private/rest/delete/${id}`,
    method: 'DELETE'
  })
}

/**
 * 删除个人中心48
 * @param {*} id 作品id
 */
export function deleteWorkById(id) {
  return request({
    url: `/newgaia48/private/rest/deleteWorkById/${id}`,
    method: 'GET'
  })
}

/**
 * 删除个人中心学院作品
 * @param {*} id 作品id
 */
export function deleteCwork(id) {
  return request({
    url: `/college/private/rest/deleteCwork/${id}`,
    method: 'POST'
  })
}

/**
 * 删除个人中心学院教程
 * @param {*} id 教程id
 */
export function deleteCourse(id) {
  return request({
    url: `/college/private/rest/deleteCourse/${id}`,
    method: 'GET'
  })
}

/**
 * 删除个人中心素材
 * @param {*} id 作品id
 */
export function deleteMaterial(id) {
  return request({
    url: `/material/private/rest/deleteMaterial/${id}`,
    method: 'GET'
  })
}

/**
 * 获取编辑48作品返回的信息
 */
export function getOwnWork(hid) {
  let url = `/newgaia48/private/rest/getOwnWork/${hid}`
  return request({
    url: url,
    method: 'GET'
  })
}

/**
 * 获取编辑48作品返回的信息
 */
export function updateCwork(data) {
  let url = `/college/private/rest/updateCwork/${data.cworkId}`
  return request({
    url: url,
    method: 'POST',
    data
  })
}

/**
 * 关注动态
 */
export function dynamicFocus(data) {
  let url = `${baseUrl}/private/rest/dynamic/focus`
  return request({
    url: url,
    method: 'POST',
    data
  })
}

/**
 * 与我相关
 */
export function dynamicRelated(data) {
  let url = `${baseUrl}/private/rest/dynamic/related`
  return request({
    url: url,
    method: 'POST',
    data
  })
}

/**
 * 关注列表
 */
export function followList(data) {
  let url = `${baseUrl}/private/rest/followList`
  return request({
    url: url,
    method: 'POST',
    data
  })
}

/**
 * 粉丝列表
 */
export function followedList(data) {
  let url = `${baseUrl}/private/rest/followedList`
  return request({
    url: url,
    method: 'POST',
    data
  })
}

/**
 * 黑名单列表
 */
export function banList(data) {
  let url = `${baseUrl}/private/rest/banList`
  return request({
    url: url,
    method: 'POST',
    data
  })
}

/**
 * 黑名单列表
 */
export function banUser(id) {
  let url = `${baseUrl}/private/rest/ban/${id}`
  return request({
    url: url,
    method: 'GET',
  })
}

/**
 * 作品收藏列表
 */
export function collections(data) {
  let url = `/works/private/rest/collections`
  return request({
    url: url,
    method: 'POST',
    data
  })
}

/**
 * 素材收藏列表
 */
export function getPersonalCollectMaterial(data) {
  let url = `/material/private/rest/getPersonalCollectMaterial`
  return request({
    url: url,
    method: 'POST',
    data
  })
}

/**
 * 教程收藏列表
 */
export function personalCollect(data) {
  let url = `/college/private/rest/personalCollect`
  return request({
    url: url,
    method: 'POST',
    data
  })
}
